export const SHOW_PAGE = "SHOW_PAGE";
export const SHOW_PAGE_FAIL = "SHOW_PAGE_FAIL";

    export const SHOW_IMG_SEARCH = "SHOW_IMG_SEARCH";
    export const SHOW_IMG_SEARCH_FAIL = "SHOW_IMG_SEARCH_FAIL";    